export const inputStyles = {
  width: "80%",
  textAlign: "center",
  "& .MuiInputBase-root": {
    border: "1px solid #ccc",
    borderRadius: "4px",
    padding: "6px 12px",
  },
  "& input": {
    padding: 0, // avoid double padding
  },
};
